module.exports = __webpack_public_path__ + "img/entrance_tc.615a1520.png";